// Sample photos (stock images) shown on the Gallery page until the school publishes its own albums in
// Admin > Gallery. The owner chose to keep them until then (2026-10-05).
const SAMPLE_GALLERY = [
  {
    id: 'sample-1',
    title: 'Classroom Learning',
    category: 'classroom',
    description: 'Students engaged in interactive learning activities in our modern classrooms',
    images: [
      {
        src: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&q=80',
        alt: 'Classroom Learning photo 1'
      },
      {
        src: 'https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=800&q=80',
        alt: 'Classroom Learning photo 2'
      },
      {
        src: 'https://images.unsplash.com/photo-1509062522246-3755977927d7?w=800&q=80',
        alt: 'Classroom Learning photo 3'
      },
      {
        src: 'https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=800&q=80',
        alt: 'Classroom Learning photo 4'
      },
      {
        src: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=800&q=80',
        alt: 'Classroom Learning photo 5'
      }
    ]
  },
  {
    id: 'sample-2',
    title: 'Outdoor Activities',
    category: 'activities',
    description: 'Children enjoying outdoor play and physical activities in our spacious playground',
    images: [
      {
        src: 'https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=800&q=80',
        alt: 'Outdoor Activities photo 1'
      },
      {
        src: 'https://images.unsplash.com/photo-1551958219-acbc608c6377?w=800&q=80',
        alt: 'Outdoor Activities photo 2'
      },
      {
        src: 'https://images.unsplash.com/photo-1622547748225-3fc4abd2cca0?w=800&q=80',
        alt: 'Outdoor Activities photo 3'
      },
      {
        src: 'https://images.unsplash.com/photo-1517164850305-99a3e65bb47e?w=800&q=80',
        alt: 'Outdoor Activities photo 4'
      }
    ]
  },
  {
    id: 'sample-3',
    title: 'Art Projects',
    category: 'art',
    description: 'Creative art sessions fostering imagination and artistic expression',
    images: [
      {
        src: 'https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=800&q=80',
        alt: 'Art Projects photo 1'
      },
      {
        src: 'https://images.unsplash.com/photo-1596548438137-d51ea5c83ca5?w=800&q=80',
        alt: 'Art Projects photo 2'
      },
      {
        src: 'https://images.unsplash.com/photo-1581291518857-4e27b48ff24e?w=800&q=80',
        alt: 'Art Projects photo 3'
      },
      {
        src: 'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=800&q=80',
        alt: 'Art Projects photo 4'
      },
      {
        src: 'https://images.unsplash.com/photo-1541961017774-22349e4a1262?w=800&q=80',
        alt: 'Art Projects photo 5'
      }
    ]
  },
  {
    id: 'sample-4',
    title: 'Science Lab',
    category: 'classroom',
    description: 'Hands-on science experiments in our well-equipped laboratory',
    images: [
      {
        src: 'https://images.unsplash.com/photo-1532094349884-543bc11b234d?w=800&q=80',
        alt: 'Science Lab photo 1'
      },
      {
        src: 'https://images.unsplash.com/photo-1628595351029-c2bf17511435?w=800&q=80',
        alt: 'Science Lab photo 2'
      },
      {
        src: 'https://images.unsplash.com/photo-1567427017947-545c5f8d16ad?w=800&q=80',
        alt: 'Science Lab photo 3'
      },
      {
        src: 'https://images.unsplash.com/photo-1582719471384-894fbb16e074?w=800&q=80',
        alt: 'Science Lab photo 4'
      }
    ]
  },
  {
    id: 'sample-5',
    title: 'Sports Day',
    category: 'events',
    description: 'Annual sports day celebrating teamwork and athletic achievements',
    images: [
      {
        src: 'https://images.unsplash.com/photo-1519766304817-4f37bda74a26?w=800&q=80',
        alt: 'Sports Day photo 1'
      },
      {
        src: 'https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=800&q=80',
        alt: 'Sports Day photo 2'
      },
      {
        src: 'https://images.unsplash.com/photo-1517649763962-0c623066013b?w=800&q=80',
        alt: 'Sports Day photo 3'
      },
      {
        src: 'https://images.unsplash.com/photo-1593006421165-03b8c0e2c57f?w=800&q=80',
        alt: 'Sports Day photo 4'
      },
      {
        src: 'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=800&q=80',
        alt: 'Sports Day photo 5'
      }
    ]
  },
  {
    id: 'sample-6',
    title: 'Music Class',
    category: 'activities',
    description: 'Students exploring musical talents and learning various instruments',
    images: [
      {
        src: 'https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=800&q=80',
        alt: 'Music Class photo 1'
      },
      {
        src: 'https://images.unsplash.com/photo-1510915361894-db8b60106cb1?w=800&q=80',
        alt: 'Music Class photo 2'
      },
      {
        src: 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=800&q=80',
        alt: 'Music Class photo 3'
      },
      {
        src: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=80',
        alt: 'Music Class photo 4'
      }
    ]
  },
  {
    id: 'sample-7',
    title: 'Library',
    category: 'classroom',
    description: 'Our extensive library promoting reading and knowledge exploration',
    images: [
      {
        src: 'https://images.unsplash.com/photo-1521587760476-6c12a4b040da?w=800&q=80',
        alt: 'Library photo 1'
      },
      {
        src: 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=800&q=80',
        alt: 'Library photo 2'
      },
      {
        src: 'https://images.unsplash.com/photo-1507842217343-583bb7270b66?w=800&q=80',
        alt: 'Library photo 3'
      },
      {
        src: 'https://images.unsplash.com/photo-1512820790803-83ca734da794?w=800&q=80',
        alt: 'Library photo 4'
      }
    ]
  },
  {
    id: 'sample-8',
    title: 'Annual Function',
    category: 'events',
    description: 'Celebrating achievements and talents at our annual day event',
    images: [
      {
        src: 'https://images.unsplash.com/photo-1523580494863-6f3031224c94?w=800&q=80',
        alt: 'Annual Function photo 1'
      },
      {
        src: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80',
        alt: 'Annual Function photo 2'
      },
      {
        src: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=800&q=80',
        alt: 'Annual Function photo 3'
      },
      {
        src: 'https://images.unsplash.com/photo-1511578314322-379afb476865?w=800&q=80',
        alt: 'Annual Function photo 4'
      },
      {
        src: 'https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?w=800&q=80',
        alt: 'Annual Function photo 5'
      }
    ]
  },
  {
    id: 'sample-9',
    title: 'Field Trip',
    category: 'activities',
    description: 'Educational field trips enhancing learning beyond the classroom',
    images: [
      {
        src: 'https://images.unsplash.com/photo-1544776193-352d25ca82cd?w=800&q=80',
        alt: 'Field Trip photo 1'
      },
      {
        src: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=800&q=80',
        alt: 'Field Trip photo 2'
      },
      {
        src: 'https://images.unsplash.com/photo-1488190211105-8b0e65b80b4e?w=800&q=80',
        alt: 'Field Trip photo 3'
      },
      {
        src: 'https://images.unsplash.com/photo-1577896851905-483f0aef0a2f?w=800&q=80',
        alt: 'Field Trip photo 4'
      }
    ]
  }
];

export default SAMPLE_GALLERY;
